import type { Options as MarkdownOptions } from "react-markdown"

import { type ArtifactDownloadLine, artifactDownloadLineOf, withoutArtifactDownloadLine } from "../utils/chatResponseText"
import { stripOuterMarkdownFence } from "../utils/stripOuterMarkdownFence"
import { streamSafeMarkdown } from "../utils/streamSafeMarkdown"
import { chatRemarkPlugins, userMessageRemarkPlugins } from "./chatMarkdownPipeline"

export type ChatMessageRole = "user" | "assistant"

export interface ChatMessageMarkdownOptions {
  role: ChatMessageRole
  isStreaming: boolean
}

export interface ChatMessageMarkdown {
  markdown: string
  downloadLine: ArtifactDownloadLine | null
}

export function chatMessageMarkdown(content: string, { role, isStreaming }: ChatMessageMarkdownOptions): ChatMessageMarkdown {
  if (role === "user") return { markdown: content, downloadLine: null }
  const unfenced = stripOuterMarkdownFence(content)
  const shown = isStreaming ? streamSafeMarkdown(unfenced) : unfenced
  const downloadLine = artifactDownloadLineOf(shown)
  if (!downloadLine) return { markdown: shown, downloadLine: null }
  return { markdown: withoutArtifactDownloadLine(shown).trim(), downloadLine }
}

export function chatRemarkPluginsFor(role: ChatMessageRole): NonNullable<MarkdownOptions["remarkPlugins"]> {
  return role === "user" ? userMessageRemarkPlugins : chatRemarkPlugins
}
